/* global Popper */
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['hint'];

  connect() {
    this.instance = Popper.createPopper(this.element, this.hintTarget, {
      placement: 'right',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
      ],
    });
  }

  show() {
    this.#visible = true;
  }

  hide() {
    this.#visible = false;
  }

  disconnect() {
    this.instance.destroy();
  }

  get #visible() {
    return !this.hintTarget.classList.contains('hidden');
  }

  set #visible(value) {
    if (value === this.#visible) {
      return;
    }

    this.hintTarget.classList.toggle('hidden', !value);

    this.instance.setOptions((options) => ({
      ...options,
      modifiers: [...options.modifiers, { name: 'eventListeners', enabled: value }],
    }));
  }
}
